$(document).ready(function ($) {
  //1 TIMELINE PRODUCT PAGE
  const firstTabItem = $(".tab-item:first");
  firstTabItem.addClass("active");
  const totalItems = $(".item").length;
  const initialWidth = 100 / totalItems;
  const firstItem = $(".item:first");
  firstItem.addClass("active");
  firstItem.css("width", "calc(" + initialWidth + "% + 10%)");
  firstItem.find(".bottom-content").show();
  firstItem.find(".bottom-content-inner").css("opacity", 1);
  $(".item:not(:first)").css("width", initialWidth + "%");
  $(".item:not(:first)").find(".bottom-content-inner").css("opacity", 0);
  function handleVideoPlayback(isActive) {
    const videos = $(".item video");
    videos.each(function () {
      this.pause();
    });
    if (isActive) {
      const activeVideo = $(".item.active video")[0];
      if (activeVideo) {
        activeVideo.currentTime = 0;
        activeVideo.play();
      }
    }
  }
  $(".item-top-content").on("click", function () {
    const clickedItem = $(this).closest(".item");
    if (!clickedItem.hasClass("active")) {
      $(".item").removeClass("active");
      $(".item").css("width", initialWidth + "%");
      $(".item").find(".bottom-content-inner").css("opacity", 0);
      clickedItem.addClass("active");
      clickedItem.css("width", "calc(" + initialWidth + "% + 10%)");
      $(".bottom-content").hide();
      clickedItem.find(".bottom-content").show();
      setTimeout(function () {
        clickedItem.find(".bottom-content-inner").css("opacity", 1);
      }, 100);
      handleVideoPlayback(true);
    }
  });
  $(".timeline-content-bar").on(
    "afterChange",
    function (event, slick, currentSlide) {
      $(".timeline-tab-bar .tab-item").removeClass("active");
      $(".timeline-tab-bar .tab-item").eq(currentSlide).addClass("active");
      handleVideoPlayback(true);
    }
  );

  $(".timeline-tab-bar .tab-item").on("click", function () {
    $(".timeline-tab-bar .tab-item").removeClass("active");
    $(this).addClass("active");
    var tabIndex = $(this).index();
    $(".timeline-content-bar").slick("slickGoTo", tabIndex);
    handleVideoPlayback(true);
  });

  $(".timeline-content-bar").slick({
    dots: false,
    infinite: false,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  // Testimonials
  $(".testimonials-container").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    variableWidth: true,
    prevArrow: false,
    nextArrow: false,
  });

  //2 PRODUCT PAGE Benefits Main Text (H3) break
  $("#benefits-section .custom-benefits-row .benefits-box-main-text").each(
    function () {
      var text = $(this).text();
      var words = text.split(/\s+/);
      if (words.length > 1 && words.length < 3) {
        $(this).html(words.join("<br>"));
      } else if (words.length > 2) {
        var firstTwoWords = words.slice(0, 1).join(" ");
        var remainingWords = words.slice(1).join(" ");
        $(this).html(firstTwoWords + "<br>" + remainingWords);
      }
    }
  );

  //3 Home Page Custom Image Link Blocks H3 break
  $(
    ".custom-image-link-blocks-section .image-link-blocks__item .image-link-blocks__title"
  ).each(function () {
    var text = $(this).text();
    var words = text.split(/\s+/);
    if (words.length > 1 && words.length < 3) {
      $(this).html(words.join("<br>"));
    } else if (words.length > 2) {
      var firstTwoWords = words.slice(0, 1).join(" ");
      var remainingWords = words.slice(1).join(" ");
      $(this).html(firstTwoWords + "<br>" + remainingWords);
    }
  });

  //4 Create BLOG SUMMARY
  $(".blog-right-side-container h2").each(function (index) {
    var headingText = $(this).text();
    var modifiedText = headingText.replace(/\s/g, "");
    $(this).attr("id", modifiedText);
    var newListItem = $(
      '<li><a class="summary-id-link" href="#' +
        modifiedText +
        '">' +
        headingText +
        "</a></li>"
    );

    $(".blog-post-summary-nav").append(newListItem);
    $(".blog-post-summary-nav li")
      .find("a")
      .on("click", function () {
        $(".blog-post-summary-nav li").find("a").removeClass("active");
        $(this).addClass("active");
        $(".blog-post-summary-nav li").removeClass("active");
        $(this).closest("li").addClass("active");
      });
  });

  // Check if .blog-post-summary-nav does not have any li elements
  if (!$(".blog-post-summary-nav").find("li").length) {
    $(".blog-right-side-container").css("float", "left");
  }

  // Updating review section on PDP
  // Updating review section on PDP
  var reviewSection = document.querySelector(
    ".shopify-block.shopify-app-block .jdgm-widget.jdgm-preview-badge"
  );

  var loox_rating =
    reviewSection && reviewSection.querySelector(".jdgm-prev-badge");
  var ratingCount =
    loox_rating && loox_rating.getAttribute("data-average-rating");

  if (ratingCount) {
    reviewSection.insertAdjacentHTML(
      "afterbegin",
      '<div class="cre3-rating">' + ratingCount + "</div>"
    );
    reviewSection.insertAdjacentHTML(
      "beforeend",
      '<span class="cre3-text">See all reviews</span>'
    );
    reviewSection.insertAdjacentHTML(
      "afterend",
      '<span class="cre-product-sold-count">' +
        '<img src="https://cdn.shopify.com/s/files/1/0605/3445/6508/files/cart.svg?v=1716649106"> 2740 sold in last 30 days' +
        "</span>"
    );
  }

  // Open 1st Accordian
  var firstAccordion = $(".product-details-accordian details").first();
  if (firstAccordion.length) {
    firstAccordion.attr("open", "").attr("aria-expanded", "true").css({
      overflow: "visible",
      height: "auto",
    });
  }

  // USP Bar
  $(".cre-t02-uspBarMobile .uspBar-item").on("click", function () {
    var classes = $(this).attr("class").split(" ");
    if (classes.length >= 3) {
      var thirdClass = classes[2];
      if (thirdClass === "LiveCustomerSupport") {
        return;
      }
      var isActive = $(this).hasClass("active");
      resetDropdowns();

      if (!isActive) {
        $(this).addClass("active");
        activeCreDropdownMobile(thirdClass);
      } else {
        $(this).removeClass("active");
      }
    } else {
      console.log(">>> This element does not have a third class.");
    }
  });
  function activeCreDropdownMobile(prop) {
    $(".CredropdownMobile").css({
      display: "block",
      width: "80%",
      margin: "auto",
      left: 0,
      right: 0,
      top: "75px",
      zIndex: 11,
    });
    $(`.CredropdownMobile .${prop}`).css("display", "block");
  }
  function resetDropdowns() {
    $(".cre-t02-uspBarMobile .uspBar-item").removeClass("active");
    $(".CredropdownMobile").hide();
    $(".CredropdownMobile > div").css("display", "none");
  }
  $(document).on("click", function (event) {
    if (
      !$(event.target).closest(".CredropdownMobile").length &&
      !$(event.target).closest(".cre-t02-uspBarMobile .uspBar-item").length
    ) {
      resetDropdowns();
    }
  });

  if ($(".recurpay-pdp-widget .recurpay__widget_container").length > 0) {
    $(
      "html body.cre-test3-1 .shopify-section--main-product .product-info .product-info__price"
    ).removeClass("forced_display_show");
    console.log(
      ">>> RecurPay loaded ",
      $(".recurpay-pdp-widget .recurpay__widget_container").length
    );
  } else {
    $(
      "html body.cre-test3-1 .shopify-section--main-product .product-info .product-info__price"
    ).addClass("forced_display_show");
    console.log(
      ">>> RecurPay not loaded",
      $(".recurpay-pdp-widget .recurpay__widget_container").length
    );
    $("html body.cre-test3-1 .cre3-hr-live").hide();
    $("html body.cre-test3-1 .cre3-subscription").hide();
    $("html body.cre-test3-1 .cre3-free-shipping .cre3-subscribe").hide();
  }
});

function setupClickToShowIframe() {
  document.addEventListener("DOMContentLoaded", function () {
    var triggerElement = document.getElementById("help-decodeage-section");
    var iframeContainer = document.getElementById("iframeContainer");
    var overlay = document.getElementById("iframeContainer_overlay");
    var closeIframe = document.getElementById("closeIframeContainer");

    if (triggerElement) {
      triggerElement.addEventListener("click", function () {
        overlay.style.display = "block";
        iframeContainer.style.display = "block";
      });
    }

    if (closeIframe) {
      closeIframe.addEventListener("click", function () {
        closeHelpDecodeAgeIframe();
      });
    }

    if (overlay) {
      overlay.addEventListener("click", function () {
        iframeContainer.style.display = "none";
        overlay.style.display = "none";
      });
    }
  });
}
function closeHelpDecodeAgeIframe() {
  document.getElementById("iframeContainer").style.display = "none";
  document.getElementById("iframeContainer_overlay").style.display = "none";
}
setupClickToShowIframe();

// Wo custom JS

var QtyIncDec = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this._onQuantityChanged);
  }
  _onQuantityChanged(event) {
    if (!event.target.hasAttribute("line-item-key")) {
      return;
    }
    let isPlus = false;
    if (event.target.classList.contains("button-plus")) {
      isPlus = true;
    }
    const currentQty = event.target.getAttribute("current-quantity");
    const targetQty = isPlus ? parseInt(currentQty) + 1 : (parseInt(currentQty) == 1 ? 0 : parseInt(currentQty) - 1);
    if ( targetQty > 0 ) {
      this._changeLineItemQuantity(event.target.getAttribute("line-item-key"), targetQty);
    } else {
      this._onRemoveLinkClicked(event);
    }
  }
  _onRemoveLinkClicked(event) {
    event.preventDefault();
    this._changeLineItemQuantity(event.target.getAttribute("line-item-key"), 0);
  }
  async _changeLineItemQuantity(lineKey, targetQuantity) {
    if (window.themeVariables.settings.pageType === "cart") {
      window.location.href = `${Shopify.routes.root}cart/change?id=${lineKey}&quantity=${targetQuantity}`;
    } else {
      const lineItem = this.closest("line-item");
      lineItem?.dispatchEvent(new CustomEvent("line-item:will-change", { bubbles: true, detail: { targetQuantity } }));
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
      const cartContent = await (await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: targetQuantity,
          sections: sectionsToBundle
        })
      })).json();
      const lineItemAfterChange = cartContent["items"].filter((lineItem2) => lineItem2["key"] === lineKey);
      lineItem?.dispatchEvent(new CustomEvent("line-item:change", {
        bubbles: true,
        detail: {
          quantity: lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0]["quantity"],
          cart: cartContent
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "line-item:change",
          cart: cartContent
        }
      }));
    }
  }
};
if (!window.customElements.get("qty-inc-dec")) {
  window.customElements.define("qty-inc-dec", QtyIncDec);
}